// extracted by mini-css-extract-plugin
module.exports = {"pviewStickyBottom":"sticky-bar-bottom_pviewStickyBottom__2vAHx","call":"sticky-bar-bottom_call__FfRch","smsBtn":"sticky-bar-bottom_smsBtn__1v4Lf"};